import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HubioTableComponent, HubioTableOptions } from '@hubio/hubio-common-components';
import { errorsConfig } from '../../configs/errors-table.config';
import { AuditRecord } from '../../models/dashboard.model';
import { StringUtilService } from '@core/services/string-util.service';

@Component({
  selector: 'app-errors-table',
  templateUrl: './errors-table.component.html',
  styleUrls: ['./errors-table.component.scss']
})
export class ErrorsTableComponent implements OnInit {

  @ViewChild('table', { static: true }) public table: HubioTableComponent;
  @Input() public data: AuditRecord[];

  public tableOptions: HubioTableOptions
  private tableConfig;

  constructor(
    private stringUtilService: StringUtilService
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  ngAfterViewInit(): void {
    this.setData();
  }

  private initComponent() {
    this.initMetadata();
    this.initTableOptions();
  }

  initMetadata() {
    this.tableConfig = errorsConfig.tableDefinition;
  }

  private initTableOptions() {
    this.tableOptions = {
      columns: this.tableConfig.columns,
      tooltip: this.tableConfig.tooltip,
      paginator: {
        paginate: false
      },
      cache: {
        cache: false
      }
    };
  }

  setData() {
    this._parseData(this.data);
    this.table.setData(this.data, 0);
  }

  _parseData(data: AuditRecord[]): AuditRecord[] {
    const dateColumns = this.tableOptions.columns.filter((columnConfig) => {
      return columnConfig['displayField'] == 'acreated';
    });

    data.forEach((task: AuditRecord) => {
      dateColumns.forEach((columnDef) => {
        if (task[columnDef.displayField] != null) {
          task[columnDef.displayField] = this.stringUtilService.formatDate(new Date(task[columnDef.displayField]).getTime());
        }
      });
    });

    return data;
  }

}
